/** @jsxImportSource @emotion/react */
import {
  Button,
  createStyles,
  Typography,
  useTheme,
  UtilityButton,
} from '@quickbit/qb-design-system';
import { useNavigate } from 'react-router-dom';
import {
  useAuthenticatorEnabled,
  useDeleteAuthenticator,
} from '../../api/authenticatorApi';
import { AuthenticatorEnabledStatus } from '../components/AuthenticatorEnabledStatus';

export const EnableMfaAuth = () => {
  const navigate = useNavigate();
  const styles = useStyles();
  const { spacing } = useTheme();
  const { data: authenticatorEnabled, isLoading: authenticatorEnabledLoading } =
    useAuthenticatorEnabled();
  const { mutate: deleteAuthenticator } = useDeleteAuthenticator();

  return (
    <div css={[styles.container]}>
      <div css={{ flex: 4, marginRight: spacing.xs }}>
        <Typography variant="subtitle">Two-factor authentication</Typography>
        <div
          css={{
            marginTop: spacing.xxs,
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.xxs,
          }}
        >
          <Typography variant="bodySmall">
            Two-Factor Authentication (2FA) enhances account security by
            requiring both a password and a verification code from your phone or
            authenticator app to access your account.
          </Typography>
          {authenticatorEnabled?.enabled && (
            <AuthenticatorEnabledStatus
              enabled={authenticatorEnabled.enabled}
              subtitle="Thank you for securing your account"
            />
          )}
          {authenticatorEnabled?.enabled && (
            <UtilityButton
              text="Remove authenticator"
              variant="secondary"
              icon="trash"
              color="danger"
              onClick={() => {
                deleteAuthenticator();
              }}
            />
          )}
        </div>
      </div>
      {!authenticatorEnabledLoading && !authenticatorEnabled?.enabled && (
        <Button
          css={{ flex: 1 }}
          text="Set up 2FA"
          variant="primary"
          disabled={authenticatorEnabled?.enabled}
          onClick={() => {
            void navigate('mfa');
          }}
          testId="primary-button"
        />
      )}
    </div>
  );
};
const useStyles = createStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: palette.white,
    padding: spacing.s,
  },
}));
